import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    all_missions_index: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "scheduled_events/";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    all_missions_upcoming_events: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "scheduled_events/future_events";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    one_mission_completed_events_and_stats: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/completed_events_and_stats/";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    one_mission_upcoming_events_and_stats: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/upcoming_events_and_stats/";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    one_mission_show_event: async ({ missionId, sessionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/" + sessionId;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    one_mission_show_event_recordings: async ({ missionId, sessionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/" + sessionId + "/recordings";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },



    one_mission_request_reschedule: async ({ missionId, sessionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/" + sessionId + "/request_reschedule";

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    one_mission_cancel_and_reject_user: async ({ missionId, sessionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/scheduled_events/" + sessionId + "/cancel_and_reject_user";

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

}